import React, { useMemo } from 'react';
import { Col, Container, Row, Image, Button } from 'react-bootstrap';
import { useTranslation } from 'react-i18next';
import classNames from 'classnames';
import { map, times, startCase } from 'lodash';

import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faCircleCheck } from '@fortawesome/free-solid-svg-icons';
import { routeCancerQuotePage } from '@components/HealthQuotePage';

import cancerInsuranceImg from './health-insurance-family.png';
import style from './style.module.scss';
import { Link } from 'react-router-dom';

const CallToActionSection = () => {
  const { t } = useTranslation();
  const items = useMemo(() => {
    return times(4, (n) => t(`cancerInsurancePage.headerSection.item${n + 1}`));
  }, []);

  return (
    <section className={classNames(style.bg, 'py-5')}>
      <Container className="my-5">
        <Row>
          <Col lg={10} className="mx-auto">
            <Row className="gy-5 align-items-center">
              <Col md={10} lg={5} className="order-lg-2">
                <Image src={cancerInsuranceImg as string} fluid alt="MGA Cover cancer insurance model" />
              </Col>
              <Col lg={7} className="order-lg-1">
                <h1 className="text-primary">{startCase(t('cancerInsurancePage.headerSection.title'))}</h1>
                <p className="mb-0">{t('cancerInsurancePage.headerSection.subTitle')}</p>
                <div className="my-4">
                  {map(items, (item) => (
                    <div key={item} className="fs-5 d-flex flex-row align-items-center mb-2">
                      <FontAwesomeIcon icon={faCircleCheck} size="sm" className="me-3 text-primary" />
                      <span className="d-block">{item}</span>
                    </div>
                  ))}
                </div>
                <Row>
                  <Col lg={6} md={6}>
                    <Button as={Link}
                      to={routeCancerQuotePage()}
                      variant="primary"
                      size="lg"
                      className="fw-bold p-3 w-100"
                    >
                      {t('banner.cta')}
                    </Button>
                  </Col>
                </Row>
              </Col>
            </Row>
          </Col>
        </Row>
      </Container>
    </section>
  );
};

export { CallToActionSection };
